<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div
    id="yxpPageManage"
    class="sub-body"
    :class="[$route.name === 'make' ? 'hidden-footer' : '',$route.name === 'mobileModules' ? 'hidden-footer' : '',$route.name === 'mobileBoxContent' ? 'hidden-footer' : '']"
  >
    <transition
      name="an-fade-in"
      @before-enter="beforeEnter"
      @after-enter="afterEnter"
    >
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
    </transition>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
    name: 'App',
    methods: {
        beforeEnter (e) {

        },
        afterEnter () {
            // this.$el.style.overflow = 'visible';
        },
    },
};
</script>

<style lang="scss">
  @import "@/sass/reset.scss";
  .sub-body, body {
    width: 100%;
    height: 100%;
    font-size: 14px;
    & > .el-scrollbar__bar {
      z-index: 3000;
    }
    & > .el-scrollbar__wrap {
      height: calc(100% + 17px);
      width: calc(100% + 17px);
    }
  }
  .hidden-footer {
      .portal-footer {
          display: none;
      }
  }
</style>
